import type { AUTProperty } from "@/api/queries/account";
import type { DeviceWithMapping } from "@/utils/mesh-device-utils";
import EmptyDeviceState from "./EmptyDeviceState";
import EnhancedDeviceListItem from "./EnhancedDeviceListItem";

interface DeviceListProps {
  devices: DeviceWithMapping[];
  property: AUTProperty | null;
  onDeviceClick: (device: DeviceWithMapping) => void;
  onManageNetwork: (device: DeviceWithMapping) => void;
  hasSearchQuery: boolean;
  hasFilter: boolean;
}

export default function DeviceList({
  devices,
  property,
  onDeviceClick,
  onManageNetwork,
  hasSearchQuery,
  hasFilter,
}: DeviceListProps) {
  if (devices.length === 0) {
    return <EmptyDeviceState hasSearchQuery={hasSearchQuery} hasFilter={hasFilter} />;
  }

  return (
    <div className="space-y-3">
      {devices.map((device, index) => (
        <EnhancedDeviceListItem
          key={device.id}
          device={device}
          property={property}
          index={index}
          devices={devices}
          onDeviceClick={onDeviceClick}
          onManageNetwork={onManageNetwork}
        />
      ))}
    </div>
  );
}
